import { render, staticRenderFns } from "./disabledTips.vue?vue&type=template&id=15fdf6fa"
import script from "./disabledTips.vue?vue&type=script&lang=js"
export * from "./disabledTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports